import { FC, PropsWithChildren } from 'react'
import styled from 'styled-components'

const Wrapper = styled.span`
  color: ${props => props.color};

  b {
    font-weight: 500;
  }
`

const Percent: FC<PropsWithChildren & { color: string }> = ({
  color,
  children,
}) => {
  return (
    <Wrapper color={color}>
      <b>{children}</b>%
    </Wrapper>
  )
}

export default Percent
